<template>
  <div>
    <div class="flex">
      <div class="project" v-for="project in $AllProjects" v-if="project.is_active && ![13].includes(project.id)">
        <div class="text-center"><strong>{{ project.title }}
          <template v-if="project.id === 1">(+ФДЛ)</template>
          <template v-if="project.id === 12">(+ФДК(Р))</template>
        </strong></div>
        <div v-if="projectPrices[project.id]">
          <p v-for="p in projectPrices[project.id]">
            {{ p.qty }}: <strong>{{ p.price }}</strong>
          </p>
        </div>
        <div class="text-center" v-if="createTasks[project.id]">
          <template v-if="loading[project.id]">
            <clip-loader
              :loading="true"
              :color="$constants.LOADING_COLOR"
              size="20px"
            />
          </template>
          <template v-else>
            <i class="icon-fa icon-fa-clock-o"/>
            <i @click="addTask(project.id, true)" class="pointer hover_red icon-fa icon-fa-remove"/>
          </template>
        </div>
        <div class="text-center" v-if="!projectPrices[project.id] && !createTasks[project.id]">
          <template v-if="loading[project.id]">
            <clip-loader
              :loading="true"
              :color="$constants.LOADING_COLOR"
              size="20px"
            />
          </template>
          <template v-else>
            <i @click="addTask(project.id)" class="icon-fa icon-fa-plus-square green"></i>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'

export default {
  props: ['prices', 'tasks', 'drugId'],
  data() {
    return {
      loading: {},
      projectPrices: {},
      createTasks: {}
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter((s) => s.id && s.id !== 4)
      return _.orderBy(stores, 'id');
    },
  },
  mounted() {
    this.sortData()
  },
  methods: {
    async addTask(projectId, reject = false) {
      this.loading[projectId] = true;
      this.loading = {...this.loading};
      const {data} = await api.post('/tasks/new', {
        type: 'new_product',
        reject,
        drug_id: this.drugId,
        project_id: projectId
      })
      if (data.success) {
        this.createTasks[projectId] = !reject;
        this.createTasks = {...this.createTasks};
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading[projectId] = false;
    },
    sortData() {
      this.projectPrices = this.prices.reduce((acc, p) => {
        if (!acc[p.site_id]) acc[p.site_id] = {};
        acc[p.site_id][p.qty] = {...p};
        return acc;
      }, {})
      this.createTasks = this.tasks.reduce((acc, t) => {
        (t.task_data && t.task_data.selected_projects || []).forEach((p) => {
          acc[p] = true;
        })
        return acc;
      }, {})
    }
  }
}

</script>

<style scoped>
.project {
  min-width: 60px;
  border: 1px solid lightgray;
  padding: 3px 8px;
  margin-right: 3px;
}

.green {
  color: green;
  cursor: pointer;
}

.hover_red:hover {
  color: red;
}

p {
  margin-bottom: 0;
}
</style>
